import { render } from "./Main.vue?vue&type=template&id=5aa5afd8"
const script = {}
script.render = render

export default script